import type { ReactNode } from "react";

/**
 * The one emphasis treatment on the site: a magenta rule down the left, a
 * slightly larger body, on the deeper ivory. The organisers asked for the
 * lines people miss (the price, the free-entry line, arrive-by, the Kund
 * number) to read as highlighted; one consistent accent does that without
 * colouring whole sections. Pass one line per child; each renders on its
 * own row.
 */
export function Callout({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`grid gap-1 rounded-r-xl border-l-[3px] border-magenta bg-ivory-deep py-3 pr-4 pl-4 text-[0.95rem] leading-relaxed text-ink ${className}`}
    >
      {children}
    </div>
  );
}
